// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    // 1. Overrides the default MUI error red globally
    error: {
      main: '#B91C1C', // Sophisticated premium crimson
      dark: '#991B1B', // Hover/Focus state
      light: '#FEE2E2', // Background fill for error alert boxes
    },
  }
});

export default theme;